import { render, staticRenderFns } from "./OperatorOrderDetailsView.vue?vue&type=template&id=e741dbce&scoped=true"
import script from "./OperatorOrderDetailsView.vue?vue&type=script&lang=js"
export * from "./OperatorOrderDetailsView.vue?vue&type=script&lang=js"
import style0 from "./OperatorOrderDetailsView.vue?vue&type=style&index=0&id=e741dbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e741dbce",
  null
  
)

export default component.exports